module.exports = __webpack_public_path__ + "static/img/b2b.096aba0f.png";